import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { RegisterComponent } from './modules/register/register.component';
import { BillingComponent } from './modules/billing/billing.component';
import { EmailComponent } from './modules/communication/email/email.component';
import { LogComponent } from './modules/communication/log/log.component';
import { SmsComponent } from './modules/communication/sms/sms.component';
import { ReceiptComponent } from './modules/communication/receipt/receipt.component';
import { ResultComponent } from './modules/communication/result/result.component';
import { FileComponent } from './modules/communication/file/file.component';
import { CashierComponent } from './modules/cashier/cashier.component';
import { LedgerComponent } from './modules/ledger/ledger.component';
import { SampleAcknolegeComponent } from './modules/sample-acknolege/sample-acknolege.component';
import { SampleCollectionComponent } from './modules/sample-collection/sample-collection.component';
import { ResultPrintingComponent } from './modules/result-printing/result-printing.component';
import { LandingPagelayoutComponent } from './layouts/landing-pagelayout/landing-pagelayout.component';
import { ProfileComponent } from './modules/profile/profile.component';
import { LabResultComponent } from './modules/lab-result/lab-result.component';
import { ResultFinaliseComponent } from './modules/result-finalise/result-finalise.component';
import { CreateParamComponent } from './modules/create-param/create-param.component';
import { CreateReportTemplateComponent } from './modules/create-report-template/create-report-template.component';
import { ReportComponent } from './modules/report/report.component';
import { HomeComponent } from './modules/home/home.component';
import { LoginComponent } from './modules/login/login.component';
import { SignUpComponent } from './modules/sign-up/sign-up.component';
import { AuthGuard } from './core/guard/auth.guard';
import { ResultDispatchComponent } from './modules/result-dispatch/result-dispatch.component';
import { NotFoundComponent } from './modules/not-found/not-found.component';
import { PrintReceiptComponent } from './modules/print-receipt/print-receipt.component';
import { ObsComponent } from './modules/obs/obs.component';
import { ObsFTSResultComponent } from './modules/obs-fts-result/obs-fts-result.component';
import { ObsFTTwinResultComponent } from './modules/obs-fttwin-result/obs-fttwin-result.component';
import { ObsFTTripletsResultComponent } from './modules/obs-fttriplets-result/obs-fttriplets-result.component';
import { ObsSTResultComponent } from './modules/obs-st-result/obs-st-result.component';
import { ObsTTResultComponent } from './modules/obs-tt-result/obs-tt-result.component';
import { ObsFinalizeComponent } from './modules/obs-finalize/obs-finalize.component';
import { ScanComponent } from './modules/scan/scan.component';
import { InvoiceComponent } from './modules/invoice/invoice.component';
import { EncountersComponent } from './modules/encounters/encounters.component';
import { PatientComponent } from './modules/patient/patient.component';
import { TestComponent } from './shared/components/test/test.component';
import { XRayComponent } from './modules/x-ray/x-ray.component';
import { XRayPrintComponent } from './modules/x-ray-print/x-ray-print.component';
import { OnlineFinalizeComponent } from './modules/online-finalize/online-finalize.component';
import { OnlineViewResultComponent } from './modules/online-view-result/online-view-result.component';
import { ObsResultOnlineComponent } from './modules/obs-result-online/obs-result-online.component';
import { ExportDrComponent } from './modules/export-dr/export-dr.component';
import { ExportUserComponent } from './modules/export-user/export-user.component';
import { ExportComponent } from './modules/export/export.component';
import { ExportEmployeeComponent } from './modules/export-employee/export-employee.component';
import { ChangePasswordComponent } from './modules/change-password/change-password.component';
import { ResetPasswordComponent } from './modules/reset-password/reset-password.component';
import { RadioComponent } from './modules/radio/radio.component';
import { RadioPrintComponent } from './modules/radio-print/radio-print.component';
import { RadioOthersComponent } from './modules/radio-others/radio-others.component';
import { WaitingListComponent } from './modules/waiting-list/waiting-list.component';
import { RefundAmountComponent } from './modules/refund-amount/refund-amount.component';
import { RadiologyWaitingListComponent } from './modules/radiology-waiting-list/radiology-waiting-list.component';
import { PatientBillsComponent } from './modules/patient-bills/patient-bills.component';
import { GraphChartComponent } from './modules/graph-chart/graph-chart.component';

const routes: Routes = [
  {
    path: '',
    component: LandingPagelayoutComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
      },
    ],
  },
  {
    path: 'patient',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: PatientComponent,
      },
    ],
  },
  {
    path: 'patient-bills',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: PatientBillsComponent,
      },
    ],
  },
  {
    path: 'graph-chart',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: GraphChartComponent,
      },
    ],
  },
  {
    path: 'other-radiology-results',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: RadioComponent,
      },
    ],
  },
  {
    path: 'radiology',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: RadioComponent,
      },
    ],
  },
  {
    path: 'radiology-print',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: RadioPrintComponent,
      },
    ],
  },
  {
    path: 'radiology-others',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: RadioOthersComponent,
      },
    ],
  },
  {
    path: 'online-finalise',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: OnlineFinalizeComponent,
      },
    ],
  },
  {
    path: 'reset-password/:ref',
    component: LandingPagelayoutComponent,
    children: [
      {
        path: '',
        component: ResetPasswordComponent,
      },
    ],
  },
  {
    path: 'change-password',
    component: LandingPagelayoutComponent,
    children: [
      {
        path: '',
        component: ChangePasswordComponent,
      },
    ],
  },
  {
    path: 'online-view-result',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: OnlineViewResultComponent,
      },
    ],
  },
  {
    path: 'xray',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: XRayComponent,
      },
    ],
  },
  {
    path: 'export-price',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ExportComponent,
      },
    ],
  },
  {
    path: 'export-user',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ExportUserComponent,
      },
    ],
  },
  {
    path: 'export-employee',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ExportEmployeeComponent,
      },
    ],
  },
  {
    path: 'export-dr',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ExportDrComponent,
      },
    ],
  },
  {
    path: 'print-xray',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: XRayPrintComponent,
      },
    ],
  },
  {
    path: 'login',
    component: LandingPagelayoutComponent,
    children: [
      {
        path: '',
        component: LoginComponent,
      },
    ],
  },
  {
    path: 'password-reset',
    component: LandingPagelayoutComponent,
    children: [
      {
        path: '',
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'signUp',
    component: LandingPagelayoutComponent,
    children: [
      {
        path: '',
        component: SignUpComponent,
      },
    ],
  },
  {
    path: 'scan',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ScanComponent,
      },
    ],
  },
  {
    path: 'register',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: RegisterComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'print-receipt',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: PrintReceiptComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'billing',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: BillingComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'obs',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ObsComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'obs/:id',
    component: ObsResultOnlineComponent,
  },
  {
    path: 'ft-single-result',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ObsFTSResultComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'ft-twin-result',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ObsFTTwinResultComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'ft-triplet-result',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ObsFTTripletsResultComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'second-trimester-result',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ObsSTResultComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'third-trimester-result',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ObsTTResultComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'result-dispatch',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: EncountersComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'result-dispatch/:billId',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ResultDispatchComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'obs-finalize',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ObsFinalizeComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'email',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: EmailComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'sms',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: SmsComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'receipt',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ReceiptComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'result',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ResultComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'file',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: FileComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'log',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: LogComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'payment',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: CashierComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'ledger',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: LedgerComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'acknowledge-sample',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: EncountersComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'collect-sample',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: EncountersComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'result-finalize/:billId',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ResultFinaliseComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'waiting-list',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: WaitingListComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'radiology-waiting-list',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: RadiologyWaitingListComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'refund-amount',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: RefundAmountComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'result-print/:billId',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ResultPrintingComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'Result-entry/:billId',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: LabResultComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'encounters',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: EncountersComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'finalise-encounter',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: EncountersComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'result-print',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: EncountersComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'print-invoice',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: InvoiceComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'profile',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ProfileComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'report',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ReportComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'create-parameter',
        component: CreateParamComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'create-template',
        component: CreateReportTemplateComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
